// extracted by mini-css-extract-plugin
export default {"marketsTabs":"styles_marketsTabs__dFtXI","marketsTabs__tab":"styles_marketsTabs__tab__ponb9"};